// Per-machine memory of the last-used top-level view among Dashboard / CLOB / Matching.
// Story spec: "The system remembers the last viewed view (Dashboard / CLOB / Matching)" —
// per-machine, not per-user, so localStorage rather than the user-preference service.
// Other pages (My Orders, Recent, Sectors) MUST NOT update this.

const STORAGE_KEY = 'lastViewedView';

export const TRACKED_PATHS = ['/dashboard', '/clob', '/matchings/irs'];

export const DEFAULT_VIEW = '/dashboard';

export const isTrackedPath = (path) => TRACKED_PATHS.includes(path);

export const saveLastViewedView = (path) => {
    if (typeof window === 'undefined') return;
    if (!isTrackedPath(path)) return;
    try { window.localStorage.setItem(STORAGE_KEY, path); } catch (_) { /* quota / private-mode */ }
};

export const getLastViewedView = () => {
    if (typeof window === 'undefined') return null;
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        return isTrackedPath(stored) ? stored : null;
    } catch (_) { return null; }
};
